var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SNotification'),_c('transition',{attrs:{"name":"scroll-x-transition","mode":"out-in","appear":""}},[_c('KeepAlive',{attrs:{"max":10}},[(_vm.loaded)?_c('router-view'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }